module.exports = __webpack_public_path__ + "img/party-popper.81919a22.png";